import React, { FunctionComponent, useContext, useState } from 'react'

type RootState = {
  listLoading: boolean
}

type RootFunctions = {
  setListLoading(status: boolean): void
}

const InitialState: RootState = {
  listLoading: false,
}

export const ReservationOffersContext = React.createContext<[RootState, (state: any) => void]>([InitialState, () => {
}])

export const ReservationOffersProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<RootState>(InitialState)

  return (
    <ReservationOffersContext.Provider value={[state, setState]}>
      {children}
    </ReservationOffersContext.Provider>
  )
}

export const useReservationOffers = (): RootFunctions & RootState => {
  const [state, setState] = useContext(ReservationOffersContext)

  const setListLoading = (status: boolean) => {
    setState((state: RootState) => ({
      ...state,
      listLoading: status,
    }))
  }

  return {
    setListLoading,
    ...state,
  }
}
